module.exports = __webpack_public_path__ + "fonts/30641e69-bdcf-49b9-b7c5-d9e4290f8f0f.22fdbe8b.eot";